import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../setup";

export const googleApi = createApi({
  reducerPath: "googleApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAuthUrl: builder.mutation({
      query: ({ subdomain } = {}) => ({
        url: `auth/google`,
        method: "GET",
        params: subdomain ? { subdomain } : {},
      }),
    }),
  }),
});

export const { useGetAuthUrlMutation } = googleApi;
